<template>
  <div>
    <div style=" font-size: 18px;padding-bottom: 20px;text-align: center;">
      {{this.userId ? '编辑用户' : '新增用户'}}
    </div>
    <a-form-model label-position="right" :model="form.data" :rules="formRules" ref="userForm">
      <a-form-model-item label="登录名" :label-width="formLabelWidth" prop="loginName">
        <a-input v-model="form.data.loginName" auto-complete="off" placeholder="请输入登录名"></a-input>
      </a-form-model-item>
      <a-form-model-item label="用户名" :label-width="formLabelWidth" prop="userName">
        <a-input v-model="form.data.userName" auto-complete="off" placeholder="请输入用户名"></a-input>
      </a-form-model-item>
      <a-form-model-item label="密码" :label-width="formLabelWidth" prop="password" v-if="!(this.form.data.id)">
        <a-input v-model="form.data.password" show-password auto-complete="off" placeholder="请输入密码"></a-input>
      </a-form-model-item>
      <a-form-model-item label="邮箱" :label-width="formLabelWidth" prop="email">
        <a-input v-model="form.data.email" auto-complete="off" placeholder="请输入邮箱"></a-input>
      </a-form-model-item>
      <a-form-model-item label="语言" :label-width="formLabelWidth" prop="language">
        <a-input v-model="form.data.language" auto-complete="off" placeholder="请输入语言"></a-input>
      </a-form-model-item>
    </a-form-model>
<!--    <div slot="footer" class="dialog-footer" style="text-align: center;">-->
<!--      <a-button type="primary" @click="cancel()"-->
<!--                 class="project-dialog-button">取消-->
<!--      </a-button>-->
<!--      <a-button type="primary" @click="save('userForm')"-->
<!--                 class="project-dialog-button">保存-->
<!--      </a-button>-->
<!--    </div>-->
  </div>
</template>

<script>
import { findUser, updateUser, saveUser } from '../../../api/user';
import { email, passWord } from '../../../utils/validateForm';

async function getUser() {
  if (this.form.data.id) {
    const user = await findUser(this.form.data.id);
    if (user.code === 1200) {
      this.$set(this.form.data, 'loginName', user.data.users.loginName);
      this.$set(this.form.data, 'userName', user.data.users.userName);
      this.$set(this.form.data, 'email', user.data.users.email);
      this.$set(this.form.data, 'language', user.data.users.language);
      this.$set(this.form.data, 'password', user.data.users.password);
    }
  } else {
    this.form.data = {};
  }
}

async function save() {
  this.$refs.userForm.validate(async (valid) => {
    if (valid) {
      if (this.form.data.id) {
        const resultUpdate = await updateUser(this.form.data);
        const messagesUpdate = '更新成功';
        if (resultUpdate.code === 1200) {
          // this.$message({
          //   message: messagesUpdate,
          //   type: 'success',
          // });
          this.$message.success('更新成功')
          this.getList()
          this.form.data = {};
        } else {
          // this.$message({
          //   message: '更新失败',
          //   type: 'fail',
          // });
          this.$message.success('更新失败')
        }
      } else {
        const resultAdd = await saveUser(this.form.data);
        const messagesAdd = '添加成功';
        if (resultAdd.code === 1200) {
          // this.$message({
          //   message: messagesAdd,
          //   type: 'success',
          // });
          this.$message.success(messagesAdd)
          this.getList()
          this.form.data = {};
        } else {
          // this.$message({
          //   message: '添加失败',
          //   type: 'fail',
          // });
          this.$message.success('添加失败')
        }
      }

      // if (this.onSaveHandler) {
      //   this.onSaveHandler();
      // }
    } else {
      this.$message.error('数据格式错误')

    }
  });
}

function cancel() {
  this.$refs.userForm.resetFields();
  // if (this.onCancelHandler) {
  //   this.onCancelHandler();
  // }
}

// 判断邮箱格式
const emailFormat = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入邮箱'));
  }
  if (email(value)) {
    callback();
  } else {
    return callback(new Error('邮箱输入格式不正确'));
  }
};
// 判断密码格式
const passWordFormat = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入密码'));
  }
  if (passWord(value)) {
    callback();
  }else if(value.length!==14){
      return callback(new Error('密码必须是14位！'));
  }else {
    return callback(new Error('密码必须含有大写、小写和数字！'));
  }
};


export default {
  name: 'UserEdit',
  props: {
    userId: String,
    onSaveHandler: Function,
    onCancelHandler: Function,
    getList: Function
  },
  data() {
    return {
      formLabelWidth: '90px',
      form: {
        data: {
          id: '',
          loginName: '',
          userName: '',
          email: '',
          language: '',
          password: '',
        },
      },
      formRules: {
        loginName: [
          { required: true, message: '请输入登录名', trigger: 'blur' },
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        email: [
          { required: true, validator: emailFormat, trigger: 'blur' },
        ],
        password: [
          { required: true, validator: passWordFormat, trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    userId(val) {
      this.form.data = {};
      this.form.data.id = val;
      this.getUser();
    },
  },
  created() {
    this.form.data.id = this.userId;
    this.getUser();
  },
  methods: {
    save,
    cancel,
    getUser,
  },
};
</script>

<style scoped>

</style>
